import Modal from "../Modal";
import { useTranslation } from "react-i18next";

import styles from "./index.module.scss";

const DeletedContentModal = ({
  isOpen,
  onCancel,
  onClose,
  bodyText,
  title,
}) => {
  const { t } = useTranslation("modals");
  const { t: t1 } = useTranslation("errors");
  const { t: t2 } = useTranslation("common");

  return (
    <Modal
      isOpen={isOpen}
      showConfirm={false}
      onCancel={onCancel}
      onClose={onClose}
      cancelText={t2("OK")}
      title={t(title)}
      className={styles.modalContainer}
      contentClassName="d-flex text-center"
      bodyClassName="pt-3 pb-2 text-primary"
    >
      {t1(bodyText)}
    </Modal>
  );
};

export default DeletedContentModal;
